/** Мутация входа: сохраняет выданный access token. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { saveAuthTokens } from "@/shared/store";
import { authKeys } from "./keys";

export const useLogin = () => {
	const mutation = useMutation({
		mutationFn: Api.Auth.postApiAuthLogin,
		mutationKey: authKeys.login,
		onSuccess: (response) => {
			if (response.error === null && response.data !== null) {
				saveAuthTokens(response.data.accessToken, response.data.refreshToken);
			}
		},
	});

	return {
		execute: mutation.mutateAsync,
		isPending: mutation.isPending,
	};
};
